var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarBallon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "4wsk6utbka"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.003922 0 0 0 0 0.588235 0 0 0 0 0.878431 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#0196e0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 1.5c2.048 0 3.9.6 5.24 1.558C14.653 4.067 15.5 5.468 15.5 7s-.847 2.933-2.26 3.942C11.9 11.9 10.048 12.5 8 12.5c-1.915 2.484-5.563 1.951-5.563 1.951s-.685-.1-1.523-.423c.584-.15.991-.324 1.198-.424l.1-.05.057-.03s.677-.395 1.474-1.337a2.76 2.76 0 0 0 .309-.492c-.993-.456-1.828-1.073-2.436-1.795C.903 9.052.5 8.058.5 7c0-1.532.847-2.933 2.26-3.942C4.1 2.1 5.952 1.5 8 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0196e0",
    d: "m8 8.5-1.763.927.336-1.963-1.426-1.391 1.971-.287L8 4l.882 1.786 1.971.287-1.426 1.39.336 1.964z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBallon);
export default __webpack_public_path__ + "static/media/starBallon.221332371b8bb66875552d43b3285ed6.svg";
export { ForwardRef as ReactComponent };